import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBranchRate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 60,
			height: 60,
			rx: 12,
			fill: "#D8F2FE"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_22641_40054)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M30.0498 13.5645L17.0684 21.0593V38.9413L30.0498 46.436L43.0313 38.9413V21.0593L30.0498 13.5645Z",
					fill: "#25A7DE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.418 37.5859V22.4148L30.0518 16.2754L40.6857 22.4148V37.5859L30.0518 43.7255L19.418 37.5859Z",
					fill: "url(#paint0_linear_22641_40054)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.1992 37.1349V22.8673L30.0506 17.1797L39.9019 22.8673V37.1349L30.0506 42.8226L20.1992 37.1349Z",
					fill: "#39AEE0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M17.3936 21.1065C17.2335 21.587 18.6128 22.178 19.5847 21.9673C20.5566 21.7565 29.6927 16.3953 29.9141 15.9157C29.9758 15.782 29.9857 13.9072 29.9141 13.9072C29.5927 13.9072 17.4719 20.8717 17.3936 21.1065Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M42.6443 21.1065C42.8044 21.587 41.4251 22.178 40.4532 21.9673C39.4813 21.7565 30.4316 16.3449 30.1238 15.9157C29.9649 15.694 29.9127 13.9072 30.1238 13.9072C30.4454 13.9072 42.566 20.8717 42.6443 21.1065Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .37,
					d: "M17.3793 31.2767C17.2922 31.8114 17.0797 38.5803 17.3793 38.6325C17.6789 38.6847 19.0877 37.7195 19.1658 37.2761C19.244 36.8327 19.2701 32.1897 19.1658 31.7462C19.0614 31.3028 17.5245 30.3859 17.3793 31.2767Z",
					fill: "#5FC1EB"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .37,
					d: "M42.6699 31.2767C42.757 31.8114 42.9697 38.5803 42.6699 38.6325C42.3701 38.6847 40.9615 37.7195 40.8833 37.2761C40.805 36.8327 40.7789 32.1897 40.8833 31.7462C40.9876 31.3028 42.5247 30.3859 42.6699 31.2767Z",
					fill: "#5FC1EB"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .37,
					d: "M17.7064 38.817C17.8636 39.0484 29.5546 45.9607 29.7308 45.9607C29.8193 45.9607 29.9366 44.2428 29.9366 44.0512C29.9366 43.517 19.5977 38.0264 19.4169 37.9755C19.1496 37.9004 17.5471 38.5822 17.7064 38.817Z",
					fill: "#5FC1EB"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .37,
					d: "M42.4157 38.9973C42.2585 39.2288 30.3484 46.1183 30.1723 46.1183C30.134 46.1183 30.1317 43.9805 30.2112 43.9012C30.5891 43.5233 40.4489 38.0263 40.63 37.9753C40.8971 37.9 42.5752 38.7624 42.4157 38.9973Z",
					fill: "#5FC1EB"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .37,
					d: "M20.6497 36.7535C19.953 32.8002 20.3414 32.551 25.2452 30.8811C30.149 29.2111 38.4447 24.9055 39.1728 26.7749C39.9011 28.6442 39.6512 36.5982 39.4858 37.0333C39.3205 37.4684 30.7568 42.3894 30.0497 42.4011C29.3427 42.4126 20.7279 37.1975 20.6497 36.7535Z",
					fill: "#D1F0FE"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M39.6907 22.9655C39.5176 22.9236 30.6152 17.7784 30.1127 17.8166C29.636 17.8528 23.4327 20.7539 20.8895 22.946C20.2113 23.5305 20.4591 32.2593 21.0851 32.0985C21.7111 31.9378 22.1775 28.4101 29.0669 26.4283C35.8507 24.4766 38.8017 26.1652 39.5376 26.4674C39.7456 26.5528 40.0845 23.0608 39.6907 22.9655Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M19.418 37.5859V22.4148L30.0518 16.2754L40.6857 22.4148V37.5859L39.9032 37.1341C39.9032 37.1341 39.9506 23.9464 39.667 23.5327C38.6555 22.0569 30.789 18.4686 29.4978 18.868C28.1767 19.2766 21.1823 22.2546 20.3998 23.5067C20.1363 23.9282 20.2007 37.1341 20.2007 37.1341L19.418 37.5859Z",
					fill: "#39AEE0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M32.0391 24.4845C34.6886 25.6922 38.6795 25.7133 39.0447 25.483C39.4099 25.2528 39.6528 23.5526 39.0789 23.2657C38.5051 22.9787 33.9583 20.5576 32.7584 20.8184C31.5585 21.0793 31.5708 24.271 32.0391 24.4845Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .8,
					d: "M17.0684 26.507C17.0684 26.467 17.1805 21.4636 17.3925 21.1066C17.6045 20.7496 29.7704 14.0032 30.1241 13.9074C30.4779 13.8116 35.035 16.4426 35.035 16.4426L30.0498 13.5645L17.0684 21.0593V26.507Z",
					fill: "#25A7DE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.6973 18.958C34.6973 18.958 40.4 22.2025 40.4781 22.5677C40.5563 22.9329 40.6847 32.7375 40.6847 32.7375C40.6847 32.7375 40.7386 22.8329 40.6847 22.4149C40.6306 21.9967 34.6973 18.958 34.6973 18.958Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.4173 30.729C19.4173 30.729 19.2279 22.5273 19.3241 22.2612C19.4203 21.9952 30.0512 16.2754 30.0512 16.2754C30.0512 16.2754 19.786 22.1438 19.5747 22.5154C19.3632 22.8872 19.4173 30.729 19.4173 30.729Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .8,
					d: "M17.0684 38.9404L30.0498 46.4353L43.0313 38.9404V34.8674C43.0313 34.8674 42.9228 38.4232 42.6574 38.8663C42.3922 39.3094 30.764 46.072 30.1715 46.1178C29.5791 46.1635 17.6911 39.1011 17.3796 38.6316C17.0684 38.1621 17.0684 29.8281 17.0684 29.8281V38.9404Z",
					fill: "#25A7DE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.4171 33.7041C19.4171 33.7041 19.3804 37.203 19.5743 37.4968C19.7683 37.7905 24.8125 40.7027 24.8125 40.7027C24.8125 40.7027 19.3475 37.8776 19.2966 37.695C19.2456 37.5124 19.4171 33.7041 19.4171 33.7041Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M23.81 40.7715C23.4267 40.7725 22.3531 41.2024 22.5853 41.4563C22.7725 41.6611 29.2074 45.5632 29.9374 45.8315C30.1754 45.919 30.1527 44.3979 29.8332 43.9065C29.6964 43.6961 24.9974 40.7685 23.81 40.7715Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.6215 16.5155C34.3101 16.5996 35.3519 17.911 35.8475 18.0283C36.3431 18.1457 37.0213 17.7934 36.7865 17.5522C36.5518 17.311 35.1041 16.385 34.6215 16.5155Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.9319 17.8164C36.4596 17.9428 37.3308 20.0146 37.7038 20.3831C38.0768 20.7518 41.3897 21.3974 41.3137 20.8004C41.2377 20.2035 37.5955 17.6389 36.9319 17.8164Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M36.0369 40.8062C35.7573 42.0273 35.8021 42.747 35.9586 42.7548C36.1152 42.7627 41.7918 39.3462 41.9467 39.1959C42.1015 39.0457 41.0367 38.0651 40.5985 38.1322C40.1601 38.1993 36.1412 40.3499 36.0369 40.8062Z",
					fill: "#39AEE0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M20.1073 22.7635C19.9702 22.3523 19.5505 22.3547 19.5122 22.8133C19.474 23.2718 19.4084 31.7727 19.5752 31.7857C19.7419 31.7988 20.0941 31.3814 20.1071 31.1858C20.1203 30.99 20.1725 22.9592 20.1073 22.7635Z",
					fill: "#39AEE0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M39.9951 22.8161C39.9727 22.978 39.8908 31.0034 39.9951 31.0034C40.0995 31.0034 40.569 30.6252 40.569 30.4295C40.569 30.2339 40.4516 22.6463 40.3994 22.6072C40.3473 22.5683 40.0132 22.6851 39.9951 22.8161Z",
					fill: "#39AEE0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M30.0499 17.0463C30.0499 17.204 25.4756 19.8145 25.3679 19.8145C25.2603 19.8145 25.2994 19.1102 25.4462 19.0123C25.593 18.9144 30.0172 16.2538 30.0499 16.342C30.0826 16.43 30.0499 16.915 30.0499 17.0463Z",
					fill: "#39AEE0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.4913 38.1964C39.1991 38.1853 38.2125 38.759 38.2872 39.0397C38.362 39.3203 38.9661 39.6233 39.1265 39.4608C39.2868 39.2982 39.6826 38.2038 39.4913 38.1964Z",
					fill: "#25A7DE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.8696 38.3945C39.7693 38.487 39.5504 38.8159 39.7589 38.9764C39.9672 39.137 40.5803 38.7134 40.4897 38.5889C40.3991 38.4644 39.9994 38.2749 39.8696 38.3945Z",
					fill: "#25A7DE"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M38.4326 38.7579C38.1893 39.0874 39.1871 39.3063 39.3172 39.029C39.4473 38.7516 39.6556 38.1673 39.492 38.1964C39.3281 38.2254 38.5651 38.5781 38.4326 38.7579Z",
					fill: "#39AEE0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.2917 38.959C38.2917 38.959 38.3731 39.2397 38.6689 39.4132C38.9014 39.5495 39.1016 39.5189 39.1605 39.4179C39.1605 39.4179 38.979 39.6546 38.6766 39.5135C38.2031 39.2925 38.2917 38.959 38.2917 38.959Z",
					fill: "#39AEE0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M39.9779 38.4016C39.7525 38.6443 39.9276 38.9944 40.0542 38.9747C40.1808 38.9551 40.558 38.7057 40.487 38.5873C40.4161 38.4689 40.0272 38.3485 39.9779 38.4016Z",
					fill: "#39AEE0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.8682 38.3926C39.8682 38.3926 39.6611 38.6772 39.7442 38.8412C39.8273 39.0052 39.9449 39.0045 39.9449 39.0045C39.9449 39.0045 39.6769 39.1603 39.6275 38.9776C39.5422 38.6614 39.8682 38.3926 39.8682 38.3926Z",
					fill: "#39AEE0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.7153 16.9597C28.016 16.775 27.4509 17.228 27.1441 17.5762C26.8374 17.9243 27.0085 18.1312 27.394 18.0627C27.7796 17.9939 29.01 17.0374 28.7153 16.9597Z",
					fill: "#25A7DE"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M28.7131 16.9589C28.2401 16.7975 27.6417 17.1109 27.4537 17.2777C27.2657 17.4444 27.6353 17.9173 27.8899 17.8164C28.1444 17.7155 28.9287 17.0325 28.7131 16.9589Z",
					fill: "#39AEE0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.3198 17.3936C27.3198 17.3936 26.5296 17.9111 26.6183 18.1677C26.707 18.4242 27.6542 17.9565 27.6542 17.9565C27.6542 17.9565 27.1629 18.1166 27.0516 17.8987C26.9403 17.6805 27.3198 17.3936 27.3198 17.3936Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.8709 37.6896C19.4987 37.7826 20.6016 38.5399 20.8624 38.5791C21.1233 38.6182 20.8661 37.9539 20.7396 37.8397C20.647 37.7558 20.0795 37.6374 19.8709 37.6896Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.0403 38.4208L16.6396 30.6055C16.1216 31.7864 16 32.8946 16 32.8946L16.8743 34.3726L30.0403 42.0193L43.2063 34.3726L43.9992 32.8946C43.9992 32.8946 44.0008 31.7864 43.5193 30.6055L30.0403 38.4208Z",
					fill: "#39AEE0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.8743 34.3726L16 32.8945L30.0403 41.1196L43.9992 32.8945L43.2064 34.3726L30.0403 42.0193L16.8743 34.3726Z",
					fill: "#25A7DE"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .6,
					d: "M16 32.8945L16.8743 34.3725L17.0738 34.4954L17.0693 34.9355C17.0693 34.9355 17.8207 35.3185 19.2964 36.1333C19.3464 36.161 20.2236 37.0875 20.2236 37.0875C20.2236 37.0875 29.708 42.8224 30.0507 42.8224C30.4931 42.8224 39.9026 36.9607 39.9026 36.9607C39.9026 36.9607 40.6354 36.3453 40.7084 36.3024L43.032 35.0856V34.4738L43.2064 34.3726L43.9994 32.8947L30.0405 41.1189L16 32.8945Z",
					fill: "#39AEE0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .69,
					d: "M30.041 38.4208V41.1197L43.9999 32.8946C43.9999 32.8946 43.9441 31.5415 43.52 30.6055L30.041 38.4208Z",
					fill: "#5FC1EB"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M17.3282 31.1982C17.0719 31.1982 17.282 33.4676 18.0608 33.9893C19.2979 34.8179 26.756 39.2139 27.2444 39.2192C27.582 39.2228 27.5644 37.295 27.4628 37.1455C27.2707 36.8624 17.7108 31.1982 17.3282 31.1982Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M34.1855 36.089C34.0235 36.2563 34.0457 38.3773 34.3224 38.3142C34.5992 38.2511 38.8146 36 40.8026 34.5405C42.7906 33.081 43.0711 31.1563 42.6236 31.1989C42.6236 31.1989 34.518 35.7458 34.1855 36.089Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.2129 37.1201C23.2129 37.1201 29.6295 40.9679 30.0404 40.9679C30.4513 40.9679 35.5741 37.8588 35.5741 37.8588C35.5741 37.8588 30.197 41.2679 30.0506 41.2679C29.9366 41.2677 23.2129 37.1201 23.2129 37.1201Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_22641_40054",
			x: 12,
			y: 13.5645,
			width: 36,
			height: 40.8721,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_22641_40054"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_22641_40054",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_22641_40054",
			x1: 30.0518,
			y1: 13.8565,
			x2: 30.0518,
			y2: 42.1899,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#5FC1EB" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .1992,
					stopColor: "#94DFFF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .4408,
					stopColor: "#AAE6FF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .7042,
					stopColor: "#C5EEFF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .9816,
					stopColor: "#DAF4FF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EEFAFF"
				})
			]
		})] })
	]
});
export default SvgBranchRate;
